import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <span className={styles.brand}>Pumy Betonu</span>
          <span className={styles.copy}>&copy; {new Date().getFullYear()}</span>
        </div>
        <div className={styles.right}>
          <span className={styles.madeBy}>made by: misha@nolo.consulting</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
